import { Box, Typography, Divider } from '@mui/material'
import React from 'react'
import signInMarkettingImg from 'assets/signInMarkettingImg.png'
import UserSecurityIcon from 'assets/signIn/UserSecurityIcon.svg'
import ReputationDataIcon from 'assets/signIn/ReputationDataIcon.svg'
import BusinessInformationVerificationIcon from 'assets/signIn/BusinessInformationVerificationIcon.svg'
import FinancialGraphIcon from 'assets/signIn/FinancialGraphIcon.svg'
import LoggedOutControls from 'components/Auth/LoggedOutControls'

const sx = {
  root: {
    backgroundColor: 'color.blue',
  },
  wrapper: {
    display: 'flex',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    blockSize: 'auto',
    marginBottom: '18px',
  },
  headerMsg: {
    width: '319px',
    color: '#fff',
    textAlign: 'center',
    marginBottom: '15px',
    marginTop: '18px',
    fontWeight: 600,
  },
  gettingStarted: {
    color: 'color.aqua',
    textTransform: 'uppercase',
    marginBottom: '10px',
  },
  itemText: {
    color: 'color.white',
    minHeight: '48px',
    display: 'flex',
    alignItems: 'center',
    fontSize: '14px',
    lineHeight: '18px',
    fontWeight: 400,
  },
  divider: {
    color: 'color.aqua',
    width: '311px',
  },
  itemsWrapper: {
    display: 'inline-flex',
    gap: '7.13px',
    alignItems: 'center',
    width: '311px',
    height: '55px',
  },
  number: {
    borderRadius: '57px',
    backgroundColor: 'color.aqua',
    color: 'color.blue',
    width: '17.16px',
    height: '17.16px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '9.151px',
    fontWeight: 500,
  },
  imageWrapper: {
    borderRadius: '50%',
    aspectRatio: '1/1',
    backgroundColor: 'color.white',
    height: '36.96px',
    width: '36.96px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}

const items = [
  {
    text: 'Enter your email to create your account. ',
    icon: UserSecurityIcon,
    id: 1,
  },
  {
    text: 'Use our Directory to claim your business.',
    icon: ReputationDataIcon,
    id: 2,
  },
  {
    text: 'See the public snapshot of your business.',
    icon: BusinessInformationVerificationIcon,
    id: 3,
  },
  {
    text: 'Take action with new tools and solutions!',
    icon: FinancialGraphIcon,
    id: 4,
  },
]

const SignInMob = () => {
  return (
    <Box sx={sx.root}>
      <LoggedOutControls controls={true} />
      <Box sx={sx.infoSection} backgroundColor="color.blue">
        <Box sx={sx.wrapper}>
          <img
            src={signInMarkettingImg}
            style={{
              width: '171px',
              height: '127px',
              marginTop: '80px',
            }}
            alt="sign-in-img"
          />
          <Typography variant="body1B" sx={sx.headerMsg}>
            Unlock your business’s growth potential with faster access to the services and solutions you need
          </Typography>
          <Typography variant="overline2" sx={sx.gettingStarted}>
            Getting started is easy!
          </Typography>
          {items.map((item, index) => (
            <>
              <Divider variant="middle" sx={sx.divider} />
              <Box sx={sx.itemsWrapper}>
                <Box>
                  <Typography variant="body1" sx={sx.number}>
                    {item.id}
                  </Typography>
                </Box>
                <Box sx={sx.imageWrapper}>
                  <img
                    src={item.icon}
                    alt={item.icon}
                    style={{
                      height: '28px',
                      width: '22px',
                    }}
                  />
                </Box>
                <Typography color="color.white" sx={sx.itemText}>
                  {item.text}
                </Typography>
              </Box>
            </>
          ))}
        </Box>
      </Box>
    </Box>
  )
}

export default SignInMob
